import { SCHOOLS_SUCCESS, SCHOOLS_FAILURE } from '../actions/schools';

const defaultState = {
  keys: [],
  data: {},
  err: '',
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    /**
    *  PAYLOAD: Object
    */
    case SCHOOLS_SUCCESS: {
      return {
        ...action.payload,
      };
    }

    /**
    *  PAYLOAD: Object {err: String}
    */
    case SCHOOLS_FAILURE: {
      return {
        ...state,
      };
    }
    default:
  }
  return state;
}
